"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupMembersListSkeleton = exports.GroupMemberSkeleton = exports.GroupMember = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _UserAvatar = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserAvatar"));

var _phrase = _interopRequireDefault(require("../../../libs/translationsUtils/phrase"));

var _trackingLink = _interopRequireDefault(require("@insided/deprecated-preact-components/link/tracking-link"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Envelope = _interopRequireDefault(require("@insided/destination/icons/Envelope"));

var _DoNotDisturb = _interopRequireDefault(require("@insided/destination/icons/DoNotDisturb"));

var _Button = _interopRequireDefault(require("@insided/deprecated-control/ui-components/Button"));

/* eslint-disable import/no-internal-modules */
var GroupMember = function GroupMember(props) {
  var member = props.member,
      _props$disablePopup = props.disablePopup,
      disablePopup = _props$disablePopup === void 0 ? false : _props$disablePopup,
      _props$isModeration = props.isModeration,
      isModeration = _props$isModeration === void 0 ? false : _props$isModeration,
      _props$isWidget = props.isWidget,
      isWidget = _props$isWidget === void 0 ? false : _props$isWidget,
      onRemoveMember = props.onRemoveMember,
      _props$currentUserId = props.currentUserId,
      currentUserId = _props$currentUserId === void 0 ? null : _props$currentUserId;
  var avatarStyle = isModeration ? {
    width: '40px',
    height: '40px'
  } : {};
  return (0, _preact.h)("div", {
    key: member.id,
    className: (0, _classnames.default)('group-content-container-members_member-list_list-item-outer groups-v2-styles', {
      'is-moderation': isModeration
    })
  }, (0, _preact.h)("div", {
    className: "group-content-container-members_member-list_list-item-inner groups-v2-styles"
  }, (0, _preact.h)(_UserAvatar.default, {
    key: member.id,
    user: member,
    extraClass: "thread-list-avatar avatar--fill-parent",
    showRank: true,
    optimizeAvatarResolution: true,
    disablePopup: disablePopup,
    style: avatarStyle
  }), (0, _preact.h)("div", {
    className: "group-content-container-members_member-list_list-item-info"
  }, (0, _preact.h)(_trackingLink.default, {
    className: "group-content-container-members_member-list_list-item-username",
    href: (0, _absoluteUrlRuntime.resolveUrl)(member.url),
    track: {
      type: 'Group Members Member Clicked',
      widget: 'groups-members'
    },
    gaEvents: {
      eventCategory: 'Groups',
      eventAction: 'Group Members Member Clicked',
      eventLabel: {
        Type: 'groups-members'
      }
    }
  }, member.name), (0, _preact.h)("div", {
    className: "group-content-container-members_member-list_list-item-user-role"
  }, (0, _preact.h)(_phrase.default, {
    p: member.userTitle === 'group_admin' ? 'groups.members.moderator' : 'groups.members.member'
  })))), isWidget && currentUserId && member.id !== currentUserId ? (0, _preact.h)(_Button.default, {
    secondary: true,
    className: (0, _classnames.default)('btn', 'btn--secondary', 'group-moderation__members-widget__envelope'),
    onClick: function onClick() {
      return window.location.assign("/inbox/conversation?with=".concat(member.id));
    }
  }, (0, _preact.h)(_Envelope.default, {
    className: "icon-envelope",
    width: 16
  })) : null, isModeration && member.userTitle !== 'group_admin' ? (0, _preact.h)(_Button.default, {
    secondary: true,
    className: (0, _classnames.default)('btn', 'btn--secondary', 'group-content-container-members_member-list_list-item-delete-btn'),
    onClick: function onClick() {
      onRemoveMember === null || onRemoveMember === void 0 ? void 0 : onRemoveMember(member.id);
    }
  }, (0, _preact.h)(_DoNotDisturb.default, {
    className: "icon-delete",
    width: 16
  }), " ", (0, _preact.h)(_phrase.default, {
    m: "Forum",
    p: "groups.remove"
  })) : null);
};

exports.GroupMember = GroupMember;

var GroupMemberSkeleton = function GroupMemberSkeleton(_ref) {
  var setRef = _ref.setRef,
      isShown = _ref.isShown;
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('group-content-container-members_member-list_list-item-outer--skeleton', {
      'is-shown': isShown
    }),
    ref: function ref(node) {
      setRef === null || setRef === void 0 ? void 0 : setRef(node);
    }
  }, (0, _preact.h)("div", {
    className: "group-member__item__avatar"
  }), (0, _preact.h)("div", {
    className: "group-member__item__content"
  }, (0, _preact.h)("div", {
    className: "group-member__item__title-loader"
  }), (0, _preact.h)("div", {
    className: "group-member__item__rank-loader"
  })));
};

exports.GroupMemberSkeleton = GroupMemberSkeleton;

var GroupMembersListSkeleton = function GroupMembersListSkeleton() {
  return (0, _preact.h)("div", null, (0, _preact.h)(GroupMemberSkeleton, {
    isShown: true
  }), (0, _preact.h)(GroupMemberSkeleton, {
    isShown: true
  }), (0, _preact.h)(GroupMemberSkeleton, {
    isShown: true
  }), (0, _preact.h)(GroupMemberSkeleton, {
    isShown: true
  }), (0, _preact.h)(GroupMemberSkeleton, {
    isShown: true
  }), (0, _preact.h)(GroupMemberSkeleton, {
    isShown: true
  }), (0, _preact.h)(GroupMemberSkeleton, {
    isShown: true
  }), (0, _preact.h)(GroupMemberSkeleton, {
    isShown: true
  }));
};

exports.GroupMembersListSkeleton = GroupMembersListSkeleton;